import { RoutePaths } from "@/core/constants/RoutePaths";
import {
  ONBOARDING_V2_STORAGE_KEYS,
  clearOnboardingV2WizardStorage,
  getOnboardingV2StoredStep,
  isOnboardingV2FinalStepPersisted,
  isOnboardingV2InProgress,
  isOnboardingV2InitCompleted,
  isOnboardingV2StoredUserMatching,
  shouldMaskUserSectorIdInOnboardingV2,
} from "@/shared/utils/onboardingV2Storage";

export {
  ONBOARDING_V2_STORAGE_KEYS,
  clearOnboardingV2WizardStorage,
  isOnboardingV2FinalStepPersisted,
  isOnboardingV2InProgress,
  shouldMaskUserSectorIdInOnboardingV2,
};

export function getOnboardingV2ResumePath(userId?: string): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  if (!isOnboardingV2StoredUserMatching(userId)) {
    return null;
  }

  if (!isOnboardingV2InitCompleted()) {
    return null;
  }

  const currentStep = getOnboardingV2StoredStep();

  if (currentStep === null) {
    return RoutePaths.ONBOARDING;
  }

  return `${RoutePaths.ONBOARDING}?step=${currentStep}`;
}
